import {
  CREDIT_CARD,
  INVOICE,
  PAYPAL_CHECKOUT,
  PRZELEWY24
} from '@constants/paymentMethods'
import Paypal from '@images/payment/paymentMethods/paypal.svg'
import Przelewy24 from '@images/payment/paymentMethods/przelewy24.svg'
import { useCheckoutContext } from '@pages/Checkout/routes/contexts'
import { CreditCardImages } from '@pages/Checkout/routes/Payment/components/PaymentMethod/components/CreditCardsImages'
import { Form } from '@pages/Checkout/routes/Payment/components/PaymentMethod/components/Form'
import { Icon, Image, Paragraph, Spacer, Spreader } from '@ui-kit'
import { Fragment } from 'react'
import { Trans } from 'react-i18next'
import { Row } from 'simple-flexbox'

export const useGetPaymentMethods = () => {
  const { formik } = useCheckoutContext()

  const { values } = formik

  const { country: selectedCountry } = values

  const isPoland = selectedCountry === 'PL'

  return [
    {
      id: CREDIT_CARD,
      label: (
        <Row alignItems='center' horizontal='space-between'>
          <Row>
            <Icon icon='icon-credit-card' />

            <Spreader spread={10} />

            <Trans i18nKey='subscription.credit.card.label' />
          </Row>

          <Spreader spread={5} />

          <CreditCardImages />
        </Row>
      ),
      description: <Form />,
      isVisible: true
    },
    {
      id: PAYPAL_CHECKOUT,
      label: (
        <Row alignItems='center' horizontal='space-between'>
          <Row>
            <Image src={Paypal} />

            <Spreader spread={10} />

            <Trans i18nKey='word.paypal' />
          </Row>
        </Row>
      ),
      description: (
        <Fragment>
          <Spacer space={10} />

          <Paragraph color='neutral-6'>
            <Trans i18nKey='registration.flow.credit.card.step.przelewy24.method.description' />
          </Paragraph>
        </Fragment>
      ),
      isVisible: true
    },
    {
      id: PRZELEWY24,
      label: (
        <Row alignItems='center' horizontal='space-between'>
          <Row>
            <Image src={Przelewy24} />

            <Spreader spread={10} />

            <Trans i18nKey='checkout.payment.method.przelewy24.label' />
          </Row>
        </Row>
      ),
      description: (
        <Fragment>
          <Spacer space={10} />

          <Paragraph color='neutral-6'>
            <Trans i18nKey='checkout.payment.method.paypal.description' />
          </Paragraph>
        </Fragment>
      ),
      isVisible: isPoland
    },
    {
      id: INVOICE,
      label: (
        <Row alignItems='center' horizontal='space-between'>
          <Row>
            <Icon icon='icon-article' />

            <Spreader spread={10} />

            <Trans i18nKey='registration.flow.credit.card.step.invoice.method' />
          </Row>
        </Row>
      ),
      description: (
        <Fragment>
          <Spacer space={10} />

          <Paragraph color='neutral-6'>
            <Trans i18nKey='checkout.payment.method.invoice.description' />
          </Paragraph>
        </Fragment>
      ),
      isVisible: isPoland
    }
  ]
}
